"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeedbackForm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _feedbackService = require("../../apis/feedbackService");

var _i18n = require("../../locales/i18n");

var _FeedbackFormControlled = require("../internal/FeedbackFormControlled");

var _mixpanel = require("../internal/mixpanel");

var _fullstory = require("../internal/fullstory");

var _useCampaignAndQuestions = require("./useCampaignAndQuestions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const postResponses = async (accessToken, mixpanelIntegration, mixpanelEventNameOverride, feedbackServiceBaseUrl, campaign, questions, responses, consentsToFollowup, extraFeedbackData, sessionId) => {
  const fullStorySessionUrl = (0, _fullstory.getCurrentSessionURL)();
  const fullStoryExtras = fullStorySessionUrl ? {
    fullStorySessionUrl
  } : null;
  await Promise.all((questions.result || []).map((question, questionIndex) => {
    const _response = (responses || {})[questionIndex];

    const enrichedResponse = _objectSpread(_objectSpread({}, _response), {}, {
      consentsToFollowup,
      extra: _objectSpread(_objectSpread(_objectSpread({}, _response.extra), fullStoryExtras), extraFeedbackData)
    });

    return (0, _feedbackService.postQuestionResponseVersionUrl)(feedbackServiceBaseUrl, accessToken, question._links.ingestion.href, enrichedResponse, sessionId);
  }));
  (questions.result || []).forEach((question, questionIndex) => {
    (0, _mixpanel.mxReportFeedback)({
      mixpanelIntegration,
      mixpanelEventNameOverride
    }, campaign.result, question, true, false, (responses || {})[questionIndex]);
  });
};

const getFeedbackHeader = campaign => {
  var _campaign$result;

  return /*#__PURE__*/_react.default.createElement("h1", null, (_campaign$result = campaign.result) === null || _campaign$result === void 0 ? void 0 : _campaign$result.title);
};

const getFeedbackContent = (disabled, campaign, questions, responses, questionIndex, onChange, consentsToFollowup, setConsentsToFollowup, language) => {
  if (!campaign.result || !questions.result) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_FeedbackFormControlled.FeedbackFormControlled, {
    disabled: disabled,
    language: language,
    campaign: campaign.result,
    questions: questions.result,
    responses: responses,
    onChange: _responses => {
      if (onChange) {
        onChange(_responses);
      }
    },
    currentQuestionIndex: questionIndex,
    consentsToFollowup: consentsToFollowup,
    setConsentsToFollowup: setConsentsToFollowup
  });
};

const getFeedbackFooter = (tt, disabled, campaign, questions, responses, questionIndex, onCancel, onSubmit, onGoToQuestionIndex) => {
  var _questions$result, _responses$questionIn, _questions$result2;

  const isFirstQuestion = questionIndex === 0;
  const isLastQuestion = questionIndex + 1 === ((_questions$result = questions.result) === null || _questions$result === void 0 ? void 0 : _questions$result.length);
  const isCurrentQuestionAnswered = !!responses && !!((_responses$questionIn = responses[questionIndex]) === null || _responses$questionIn === void 0 ? void 0 : _responses$questionIn.value);
  const isMultiQuestion = (((_questions$result2 = questions.result) === null || _questions$result2 === void 0 ? void 0 : _questions$result2.length) || 0) > 1;

  const pleaseAnswerTooltip = btn => {
    return /*#__PURE__*/_react.default.createElement(_reactComponents.Tooltip, {
      show: isCurrentQuestionAnswered ? false : undefined,
      contents: tt('buttons.please_answer_question_first')
    }, btn);
  };

  const cancelButton = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    type: 'link',
    onClick: onCancel,
    disabled: disabled
  }, tt('buttons.cancel')), "\xA0");

  const submitButton = pleaseAnswerTooltip( /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    type: 'primary',
    onClick: onSubmit,
    disabled: !isCurrentQuestionAnswered || disabled
  }, tt('buttons.share')));

  const prevButton = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    type: 'outline-secondary',
    onClick: () => onGoToQuestionIndex(questionIndex - 1),
    disabled: isFirstQuestion || disabled
  }, tt('buttons.back')), "\xA0");

  const nextButton = pleaseAnswerTooltip( /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    type: 'primary',
    onClick: () => onGoToQuestionIndex(questionIndex + 1),
    disabled: !isCurrentQuestionAnswered || disabled
  }, tt('buttons.next')));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cancelButton, isMultiQuestion ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, prevButton, isLastQuestion ? submitButton : nextButton) : submitButton);
}; // eslint-disable-next-line max-statements,max-lines-per-function


const useFeedbackForm = args => {
  const {
    accessToken,
    mixpanelIntegration,
    mixpanelEventNameOverride,
    disabled,
    autoSubmit,
    environment,
    campaignId,
    questionId,
    onSubmission,
    onSubmitted,
    onCancelled,
    onLoaded,
    extraFeedbackData,
    sessionId
  } = args;
  const {
    feedbackServiceBaseUrl
  } = environment;

  const [isPosting, setIsPosting] = _react.default.useState(false);

  const [consentsToFollowup, setConsentsToFollowup] = _react.default.useState(false);

  const [responses, setResponses] = _react.default.useState(undefined);

  const [currentQuestionIndex, setCurrentQuestionIndex] = _react.default.useState(0);

  const [loaded, setLoaded] = _react.default.useState(false);

  const {
    tt
  } = (0, _i18n.useDoubleTTranslation)(args.language);
  const {
    campaign,
    questions
  } = (0, _useCampaignAndQuestions.useCampaignAndQuestions)(accessToken, environment, campaignId, questionId, sessionId);

  const clearForm = () => {
    setCurrentQuestionIndex(0);
    setResponses(undefined);
    setIsPosting(false);
  };

  const handleSubmit = async () => {
    setIsPosting(true);

    if (onSubmission) {
      onSubmission();
    }

    if (!accessToken && !sessionId) {
      return;
    }

    try {
      await postResponses(accessToken || '', mixpanelIntegration, mixpanelEventNameOverride, feedbackServiceBaseUrl, campaign, questions, responses, consentsToFollowup, extraFeedbackData, sessionId);

      if (onSubmitted) {
        onSubmitted(responses);
      }

      clearForm();
    } finally {
      setIsPosting(false);
    }
  };

  (0, _react.useEffect)(() => {
    if ((campaign === null || campaign === void 0 ? void 0 : campaign.status) === 'success' && (campaign === null || campaign === void 0 ? void 0 : campaign.result) && (questions === null || questions === void 0 ? void 0 : questions.status) === 'success' && (questions === null || questions === void 0 ? void 0 : questions.result) && !loaded && onLoaded) {
      setLoaded(true);
      onLoaded(campaign.result, questions.result);
    }
  }, [campaign, questions]);
  (0, _react.useEffect)(() => {
    if (autoSubmit && responses && questions && questions.result) {
      handleSubmit();
    }
  }, [responses]);

  const handleCancel = () => {
    clearForm();
    (questions.result || []).forEach(q => {
      (0, _mixpanel.mxReportFeedback)(args, campaign.result, q, false, true);
    });

    if (onCancelled) {
      onCancelled();
    }
  };

  const feedbackHeader = getFeedbackHeader(campaign);
  const feedbackContent = getFeedbackContent(disabled || isPosting, campaign, questions, responses, currentQuestionIndex, _responses => setResponses(_responses), consentsToFollowup, setConsentsToFollowup, args.language);
  const feedbackFooter = getFeedbackFooter(tt, isPosting, campaign, questions, responses, currentQuestionIndex, handleCancel, handleSubmit, _newIndex => setCurrentQuestionIndex(_newIndex));
  return {
    feedbackHeader,
    feedbackContent,
    feedbackFooter,
    campaign,
    questions
  };
};

exports.useFeedbackForm = useFeedbackForm;